import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/icons/check-circle.svg'


const _hoisted_1 = { class: "main__section confirm-email" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    (!!_ctx.state.code && !!_ctx.state.userId)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (!!_ctx.alert.content)
            ? (_openBlock(), _createBlock(_component_Alert, {
                key: 0,
                alert: _ctx.alert,
                isConfirm: true,
                "onUpdate:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.alert.content = ''))
              }, {
                icon: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["alert"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}